import gsap from 'gsap';
import { Carousel } from '@fancyapps/ui/dist/carousel/';
import '@fancyapps/ui/dist/carousel/carousel.css';

function closeAccordionItem( item ) {
	const content = item.querySelector( '[data-target="accordion-with-slider-content"]' );
	const trigger = item.querySelector( '[data-target="accordion-with-slider-trigger"]' );

	item.dataset.state = 'closed';

	if ( trigger ) {
		trigger.setAttribute( 'aria-expanded', 'false' );
	}

	if ( content ) {
		content.setAttribute( 'aria-hidden', 'true' );
		gsap.to( content, { height: 0, duration: 0.5, ease: 'expo.inOut' } );
	}
}

function openAccordionItem( item ) {
	const content = item.querySelector( '[data-target="accordion-with-slider-content"]' );
	const trigger = item.querySelector( '[data-target="accordion-with-slider-trigger"]' );
	const sliderEl = item.querySelector( '[data-name="accordion-with-slider-slider"]' );

	item.dataset.state = 'open';

	if ( trigger ) {
		trigger.setAttribute( 'aria-expanded', 'true' );
	}

	if ( content ) {
		content.setAttribute( 'aria-hidden', 'false' );
		gsap.to( content, {
			height: 'auto',
			duration: 0.5,
			ease: 'expo.inOut',
			onComplete: () => {
				if ( sliderEl?.carouselInstance?.resize ) {
					sliderEl.carouselInstance.resize();
				}
			},
		} );
	}
}

function initAccordions() {
	const items = document.querySelectorAll( '[data-target="accordion-with-slider-item"]' );

	if ( ! items.length ) {
		return;
	}

	items.forEach( ( item ) => {
		const trigger = item.querySelector( '[data-target="accordion-with-slider-trigger"]' );

		if ( ! trigger ) {
			return;
		}

		trigger.addEventListener( 'click', () => {
			const isClosed = item.dataset.state === 'closed';

			items.forEach( ( otherItem ) => {
				if ( otherItem !== item && otherItem.dataset.state === 'open' ) {
					closeAccordionItem( otherItem );
				}
			} );

			if ( isClosed ) {
				openAccordionItem( item );
			} else {
				closeAccordionItem( item );
			}
		} );
	} );
}

function syncSliderButtons( carouselInstance, prevEl, nextEl ) {
	if ( ! carouselInstance ) {
		return;
	}

	const pages = typeof carouselInstance.getPages === 'function' ? carouselInstance.getPages() : [];
	const page = typeof carouselInstance.getPage === 'function' ? carouselInstance.getPage() : 0;
	let index = 0;

	if ( typeof page === 'number' ) {
		index = page;
	} else if ( pages.length ) {
		index = Math.max( 0, pages.indexOf( page ) );
	}

	const atStart = index <= 0;
	const atEnd = pages.length ? index >= pages.length - 1 : atStart;

	if ( prevEl ) {
		prevEl.classList.toggle( 'is-disabled', atStart );
		prevEl.toggleAttribute( 'disabled', atStart );
	}

	if ( nextEl ) {
		nextEl.classList.toggle( 'is-disabled', atEnd );
		nextEl.toggleAttribute( 'disabled', atEnd );
	}
}

function initSliders() {
	const sliders = document.querySelectorAll( '[data-name="accordion-with-slider-slider"]' );

	if ( ! sliders.length ) {
		return;
	}

	sliders.forEach( ( slider ) => {
		if ( slider.carouselInstance ) {
			return;
		}

		const item = slider.closest( '[data-target="accordion-with-slider-item"]' );
		const prevEl = item ? item.querySelector( '[data-name="accordion-with-slider-prev"]' ) : null;
		const nextEl = item ? item.querySelector( '[data-name="accordion-with-slider-next"]' ) : null;

		const carouselInstance = Carousel( slider, {
			center: false,
			infinite: false,
			fill: true,
			slidesPerPage: 'auto',
			transition: 'slide',
		} ).init();

		slider.carouselInstance = carouselInstance;

		const updateButtons = () => syncSliderButtons( carouselInstance, prevEl, nextEl );

		prevEl?.addEventListener( 'click', () => carouselInstance.prev() );
		nextEl?.addEventListener( 'click', () => carouselInstance.next() );

		if ( typeof carouselInstance.on === 'function' ) {
			carouselInstance.on( 'ready', updateButtons );
			carouselInstance.on( 'change', updateButtons );
			carouselInstance.on( 'refresh', updateButtons );
		} else {
			updateButtons();
		}
	} );
}

function accordionWithSlider() {
	if ( ! document.querySelector( '[data-name="accordion-with-slider"]' ) ) {
		return;
	}

	initAccordions();
	initSliders();
}

export default accordionWithSlider;
